import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "form-list-wrapper" }
const _hoisted_2 = { class: "breadcrumb-block" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, "Home")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, "Project")
], -1)
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { href: "javascript:void(0)" }
const _hoisted_9 = /*#__PURE__*/_createVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, " Latest forms ", -1)
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "form-wrap" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "" }, "search form", -1)
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { for: "" }, "Channels", -1)
const _hoisted_19 = { class: "col-lg-4" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "" }, "Sort by", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Display form")
], -1)
const _hoisted_23 = { class: "row  mt-3" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", {
  for: "all",
  class: "ml-1"
}, "All", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = { class: "col-md-4 col-6" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  for: "sent_by_me",
  class: "ml-1"
}, "Sent by me", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = { class: "col-md-4 col-6" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", {
  for: "sent_to_me",
  class: "ml-1"
}, "Sent to me", -1)
const _hoisted_32 = { class: "row align-items-center" }
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "text-muted mb-0" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "col-lg-6" }, [
  /*#__PURE__*/_createVNode("div", { class: "button-header text-right" }, [
    /*#__PURE__*/_createVNode("a", {
      href: "#/createnewtemplate",
      class: ""
    }, [
      /*#__PURE__*/_createVNode("a", {
        href: "javascript:void(0)",
        class: "btn default-btn d-inline-block"
      }, [
        /*#__PURE__*/_createVNode("svg", {
          class: "svg-inline--fa fa-plus fa-w-14",
          "aria-hidden": "true",
          focusable: "false",
          "data-prefix": "fas",
          "data-icon": "plus",
          role: "img",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 448 512",
          "data-fa-i2svg": ""
        }, [
          /*#__PURE__*/_createVNode("path", {
            fill: "currentColor",
            d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
          })
        ]),
        /*#__PURE__*/_createTextVNode(" Create form")
      ])
    ])
  ])
], -1)
const _hoisted_37 = { class: "table-responsive my-3" }
const _hoisted_38 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_39 = /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Form name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "send to users"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "created date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "updated date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { href: "javascript:void(0)" }
const _hoisted_42 = { class: "block-list email-list" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "table-button" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { colspan: "5" }, [
    /*#__PURE__*/_createVNode("p", { class: "text-danger text-center" }, [
      /*#__PURE__*/_createVNode("strong", null, "No Templates !!! Create New")
    ])
  ])
], -1)
const _hoisted_51 = { class: "my-3" }
const _hoisted_52 = { "aria-label": "Page navigation example" }
const _hoisted_53 = { class: "send-to modal-wrap xl-size" }
const _hoisted_54 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_55 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = { class: "d-block" }
const _hoisted_59 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_60 = { class: "text-muted" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = { class: "form-wrap pt-0" }
const _hoisted_64 = { disabled: "" }
const _hoisted_65 = { class: "modal-footer justify-content-between" }
const _hoisted_66 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_67 = { class: "mb-0" }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" on ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")
  const _component_TitleComponent = _resolveComponent("TitleComponent")
  const _component_TextBoxComponent = _resolveComponent("TextBoxComponent")
  const _component_RadioButtonComponent = _resolveComponent("RadioButtonComponent")
  const _component_SelectOption = _resolveComponent("SelectOption")
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_TextArea = _resolveComponent("TextArea")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("nav", _hoisted_3, [
        _createVNode("ol", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode("li", _hoisted_7, [
            _createVNode("a", _hoisted_8, _toDisplayString(_ctx.state.data.projectDetails.name), 1)
          ]),
          _hoisted_9
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Search by name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.filter.formName = $event)),
                onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
              }, null, 544), [
                [_vModelText, _ctx.state.data.filter.formName]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createVNode("select", {
                disabled: 
                _ctx.state.data.projectDetails.channels &&
                  !_ctx.state.data.projectDetails.channels.length
              ,
                class: "custom-select form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.filter.channelId = $event)),
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectDetails
                  .channels, (channel, channelIndex) => {
                  return (_openBlock(), _createBlock("option", {
                    value: channel.uuid,
                    key: channelIndex
                  }, _toDisplayString(channel.name), 9, ["value"]))
                }), 128))
              ], 40, ["disabled"]), [
                [_vModelSelect, _ctx.state.data.filter.channelId]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createVNode("select", {
                class: "custom-select form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.filter.selected = $event)),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.sortList, (sort, sortIndex) => {
                  return (_openBlock(), _createBlock("option", {
                    value: sort,
                    key: sortIndex
                  }, _toDisplayString(sort.name), 9, ["value"]))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.state.data.filter.selected]
              ])
            ])
          ])
        ])
      ]),
      _hoisted_22,
      _createVNode("div", _hoisted_23, [
        _createVNode("div", _hoisted_24, [
          _withDirectives(_createVNode("input", {
            type: "radio",
            id: "all",
            name: "gender",
            value: "all",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.filter.type = $event)),
            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
          }, null, 544), [
            [_vModelRadio, _ctx.state.data.filter.type]
          ]),
          _hoisted_25,
          _hoisted_26
        ]),
        _createVNode("div", _hoisted_27, [
          _withDirectives(_createVNode("input", {
            type: "radio",
            id: "sent_by_me",
            name: "gender",
            value: "sent_by_me",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.filter.type = $event)),
            onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
          }, null, 544), [
            [_vModelRadio, _ctx.state.data.filter.type]
          ]),
          _hoisted_28,
          _hoisted_29
        ]),
        _createVNode("div", _hoisted_30, [
          _withDirectives(_createVNode("input", {
            type: "radio",
            id: "sent_to_me",
            name: "gender",
            value: "sent_to_me",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.filter.type = $event)),
            onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
          }, null, 544), [
            [_vModelRadio, _ctx.state.data.filter.type]
          ]),
          _hoisted_31
        ])
      ]),
      _createVNode("div", _hoisted_32, [
        _createVNode("div", _hoisted_33, [
          _createVNode("h1", _hoisted_34, _toDisplayString(_ctx.state.data.projectDetails.name), 1),
          _createVNode("p", _hoisted_35, _toDisplayString(_ctx.state.data.projectDetails.description), 1)
        ]),
        _hoisted_36
      ]),
      _createVNode("div", _hoisted_37, [
        _createVNode("table", _hoisted_38, [
          _hoisted_39,
          (_ctx.templateList)
            ? (_openBlock(), _createBlock("tbody", _hoisted_40, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (form, formIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: formIndex }, [
                    _createVNode("td", {
                      onClick: ($event: any) => (_ctx.showFormView(form))
                    }, [
                      _createVNode("div", null, [
                        _createVNode("h5", null, [
                          _createVNode("a", _hoisted_41, _toDisplayString(form.title), 1)
                        ])
                      ]),
                      _createVNode("div", null, [
                        _createVNode("p", null, _toDisplayString(form.description), 1)
                      ])
                    ], 8, ["onClick"]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_42, [
                        (form.sentToUsers && form.sentToUsers.length)
                          ? (_openBlock(), _createBlock("ul", _hoisted_43, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.sentToUsers, (user, userIndex) => {
                                return (_openBlock(), _createBlock("li", {
                                  class: "active",
                                  key: userIndex
                                }, [
                                  _createTextVNode(_toDisplayString(user.email), 1),
                                  (userIndex < form.sentToUsers.length - 1)
                                    ? (_openBlock(), _createBlock("span", _hoisted_44, ", "))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("p", null, _toDisplayString(form.created_date), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("p", null, _toDisplayString(form.updated_date), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_45, [
                        _createVNode("a", {
                          title: "Edit",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.selectEditForm(form)),
                          class: "btn edit-btn mr-1"
                        }, [
                          _hoisted_46
                        ], 8, ["onClick"]),
                        _createVNode("a", {
                          title: "Send to",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.sendSelectedForm(form)),
                          class: "btn send-btn mr-1"
                        }, [
                          _hoisted_47
                        ], 8, ["onClick"]),
                        _createVNode("a", {
                          title: "View",
                          href: "javascript:void(0)",
                          class: "btn view-btn mr-0",
                          onClick: ($event: any) => (_ctx.selectForm(form))
                        }, [
                          _hoisted_48
                        ], 8, ["onClick"])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_49, [
                _hoisted_50
              ]))
        ]),
        _createVNode("div", _hoisted_51, [
          _createVNode("nav", _hoisted_52, [
            _createVNode(_component_v_pagination, {
              modelValue: _ctx.state.data.paging.getAccountFormList.currentPage,
              "onUpdate:modelValue": [
                _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.paging.getAccountFormList.currentPage = $event)),
                _ctx.nextPage
              ],
              pages: _ctx.state.data.paging.getAccountFormList.totalPages,
              "range-size": 1,
              "active-color": "#DCEDFF"
            }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_53, [
      _createVNode("div", _hoisted_54, [
        _createVNode("div", _hoisted_55, [
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, [
                _createVNode("h5", _hoisted_59, _toDisplayString(_ctx.state.data.FormData.title), 1),
                _createVNode("p", _hoisted_60, _toDisplayString(_ctx.state.data.FormData.description), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, [
                _hoisted_61
              ])
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("div", _hoisted_63, [
                _createVNode("form", null, [
                  _createVNode("fieldset", _hoisted_64, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.FormData
                        .elements, (element, elementIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "form-group",
                        key: elementIndex
                      }, [
                        (element.type === 'title')
                          ? (_openBlock(), _createBlock(_component_TitleComponent, {
                              key: 0,
                              title: element.title,
                              description: element.description,
                              editStatus: false
                            }, null, 8, ["title", "description"]))
                          : _createCommentVNode("", true),
                        (element.type === 'textbox')
                          ? (_openBlock(), _createBlock(_component_TextBoxComponent, {
                              key: 1,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'radioButton')
                          ? (_openBlock(), _createBlock(_component_RadioButtonComponent, {
                              key: 2,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'single_select')
                          ? (_openBlock(), _createBlock(_component_SelectOption, {
                              key: 3,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'checkBox')
                          ? (_openBlock(), _createBlock(_component_CheckBox, {
                              key: 4,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true),
                        (element.type === 'textArea')
                          ? (_openBlock(), _createBlock(_component_TextArea, {
                              key: 5,
                              data: element,
                              editStatus: false
                            }, null, 8, ["data"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              (_ctx.state.data.FormData)
                ? (_openBlock(), _createBlock("div", _hoisted_66, [
                    _createVNode("p", _hoisted_67, [
                      _hoisted_68,
                      _hoisted_69,
                      (
                      _ctx.state.data.FormData.owner &&
                      _ctx.state.data.FormData.owner.created_by
                    )
                        ? (_openBlock(), _createBlock("span", _hoisted_70, _toDisplayString(_ctx.state.data.FormData.owner.created_by.email), 1))
                        : _createCommentVNode("", true),
                      _hoisted_71,
                      _createVNode("span", null, _toDisplayString(_ctx.state.data.FormData.created_date), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.hideTemplateModal && _ctx.hideTemplateModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ])
  ]))
}